import { render, staticRenderFns } from "./CurrentEvent.vue?vue&type=template&id=90c3c620&scoped=true"
import script from "./CurrentEvent.vue?vue&type=script&lang=ts"
export * from "./CurrentEvent.vue?vue&type=script&lang=ts"
import style0 from "./CurrentEvent.vue?vue&type=style&index=0&id=90c3c620&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c3c620",
  null
  
)

export default component.exports